module.exports = __webpack_public_path__ + "static/media/rating_information2.e766bbbb.png";